<template>
  <div class="box-records-container">
    <div class="page-header">
      <h2>开箱记录</h2>
      <p>查看和管理设备开箱记录数据</p>
    </div>
    
    <div class="box-records-content">
      <el-card class="search-filter">
        <div class="card-content">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input placeholder="设备编号" v-model="searchParams.deviceNo" clearable />
            </el-col>
            <el-col :span="6">
              <el-select placeholder="开箱类型" v-model="searchParams.openType" clearable>
                <el-option label="正常开箱" value="normal" />
                <el-option label="强制开箱" value="forced" />
                <el-option label="异常开箱" value="abnormal" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="searchParams.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="handleSearch">搜索</el-button>
              <el-button @click="handleReset" style="margin-left: 10px;">重置</el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>
      
      <div class="table-section">
        <el-card>
          <div slot="header" class="clearfix">
            <span>开箱记录列表</span>
            <el-button type="primary" size="small" style="float: right;">导出记录</el-button>
          </div>
          <el-table :data="boxRecordsData" style="width: 100%">
            <el-table-column type="index" width="50" />
            <el-table-column prop="recordNo" label="记录编号" width="180" />
            <el-table-column prop="deviceNo" label="设备编号" width="120" />
            <el-table-column prop="deviceName" label="设备名称" width="150" />
            <el-table-column prop="openType" label="开箱类型" width="100">
              <template slot-scope="{row}">
                <el-tag :type="getOpenTypeTag(row.openType)" size="small">
                  {{ getOpenTypeName(row.openType) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="operator" label="操作人" width="100" />
            <el-table-column prop="operationTime" label="操作时间" width="180" />
            <el-table-column prop="location" label="设备位置" width="200" />
            <el-table-column prop="remark" label="备注" width="200" />
            <el-table-column label="操作" width="100" fixed="right">
              <template>
                <el-button type="text" size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination" style="margin-top: 20px;">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalRecords"
              :page-sizes="[10, 20, 50, 100]"
              :current-page="pagination.currentPage"
          :page-size="pagination.page_size"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoxRecords',
  data() {
    return {
      searchParams: {
        deviceNo: '',
        openType: '',
        dateRange: []
      },
      pagination: {
        currentPage: 1,
        page_size: 10
      },
      totalRecords: 423,
      boxRecordsData: [
        {
          id: 1,
          recordNo: 'BX-20231025-001',
          deviceNo: 'DEV-2023-001',
          deviceName: '北区智能垃圾桶A',
          openType: 'normal',
          operator: '系统管理员',
          operationTime: '2023-10-25 09:20:15',
          location: '总部北区A栋楼下',
          remark: '正常清运操作'
        },
        {
          id: 2,
          recordNo: 'BX-20231025-002',
          deviceNo: 'DEV-2023-002',
          deviceName: '北区智能垃圾桶B',
          openType: 'normal',
          operator: '系统管理员',
          operationTime: '2023-10-25 09:25:30',
          location: '总部北区B栋楼下',
          remark: '正常清运操作'
        },
        {
          id: 3,
          recordNo: 'BX-20231025-003',
          deviceNo: 'DEV-2023-010',
          deviceName: '南区回收站',
          openType: 'forced',
          operator: '张三',
          operationTime: '2023-10-25 10:10:45',
          location: '总部南区广场',
          remark: '紧急维护需要'
        },
        {
          id: 4,
          recordNo: 'BX-20231025-004',
          deviceNo: 'DEV-2023-015',
          deviceName: '智能回收柜A',
          openType: 'normal',
          operator: '李四',
          operationTime: '2023-10-25 10:35:20',
          location: '总部办公区大厅',
          remark: '正常取件操作'
        },
        {
          id: 5,
          recordNo: 'BX-20231025-005',
          deviceNo: 'DEV-2023-020',
          deviceName: '员工宿舍区垃圾桶',
          openType: 'abnormal',
          operator: '系统检测',
          operationTime: '2023-10-25 11:05:10',
          location: '员工宿舍区入口',
          remark: '异常开箱，已通知维护人员'
        }
      ]
    }
  },
  methods: {
    // 搜索开箱记录
    handleSearch() {
      this.pagination.currentPage = 1
      this.$message.success('搜索条件已应用')
    },
    
    // 重置搜索条件
    handleReset() {
      this.searchParams = {
        deviceNo: '',
        openType: '',
        dateRange: []
      }
      this.pagination.currentPage = 1
      this.$message.info('搜索条件已重置')
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.page_size = size
    },
    
    // 当前页码变化
    handleCurrentChange(current) {
      this.pagination.currentPage = current
    },
    
    // 获取开箱类型名称
    getOpenTypeName(type) {
      const typeMap = {
        'normal': '正常开箱',
        'forced': '强制开箱',
        'abnormal': '异常开箱'
      }
      return typeMap[type] || type
    },
    
    // 获取开箱类型标签类型
    getOpenTypeTag(type) {
      const tagMap = {
        'normal': 'success',
        'forced': 'warning',
        'abnormal': 'danger'
      }
      return tagMap[type] || 'default'
    }
  }
}
</script>

<style scoped>
.box-records-container {
  padding: 20px;
}

.page-header h2 {
  color: #303133;
  font-size: 24px;
  margin-bottom: 10px;
}

.page-header p {
  color: #606266;
  font-size: 14px;
  margin-bottom: 30px;
}

.search-filter {
  margin-bottom: 20px;
}

.table-section {
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
}
</style>